import { useState } from 'react';
import Style from './FJGoogleLoginNew.module.less';
import FJLoading from '../FJLoading/FJLoading';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import useLocalStore from '../../../hooks/useLocalStore';
import loading from '../../../assets/icon/loading_one.gif';
import InlineSVG from 'react-inlinesvg';
import googleIcon from '../../../assets/icon/Google.svg';
import FJConfig from '../../../config/FJConfig';

const FJGoogleLoginNew = props => {
    useLocalStore();
    let { render, popupType } = props;
    const [load, setLoad] = useState(false);
    return (
        <div className={classNames(Style.box, { [Style.box_small]: popupType })}>
            <div className={classNames(Style.login_box)} style={{ display: load ? 'none' : 'block' }}>
                <div
                    onClick={() => {
                        setLoad(true);
                        let requestPath = FJConfig.requestPath;
                        let test = window.open(
                            requestPath + '/oauth/authorize?jump_type=google',
                            '_blank',
                            'height=600,width=600,status=yes,top=200,left=400,toolbar=no,menubar=no,location=no',
                        );
                        test.opener = window;
                        let loop = setInterval(function () {
                            if (test.closed) {
                                clearInterval(loop);
                                setLoad(false);
                            }
                        }, 800);
                    }}
                    className={Style.third_btn}
                >
                    <div className={Style.third_btn_icon}>
                        <InlineSVG src={googleIcon} width={24} />
                    </div>
                    {FJLocalStore._('continue-google')}
                </div>
            </div>
            <FJLoading src={loading} loading={load} />
        </div>
    );
};
export default FJGoogleLoginNew;
